<template>
  <div class="container">
    <div class="title">{{ $t('with').Withdrawingfiatcurrency }}</div>
    <div class="info">
      <div class="left">
        <!-- 取款法币 -->
        <div class="toptit">{{ $t('with').Withdrawaloffiatcurrency }} USD</div>
        <!-- 当前余额 -->
        <div class="toplable">{{ $t('with').Currentbalance }}<span>{{ AssetBalance.toFixed(2).replace(/\.?0+$/, '') }}
            USD</span></div>
        <!-- 选择币种 -->
        <div class="tit">{{ $t('with').Currencyreceived }}</div>
        <PopoverSelect :items="RateList" :onSelect="onSelect">
          <template #reference>
            <div class="selInfo">
              <div class="left">
                <div class="symbolInfo">{{ Symbol }}</div>
                <div class="name">
                  <div class="t1">{{ Currency }}</div>
                  <div class="t2">{{ $t('with').WithdrawingfiatcurrencyTips }}</div>
                </div>
              </div>
              <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
            </div>
          </template>
        </PopoverSelect>
        <!-- 取款账户 -->
        <div class="tit">{{ $t('with').Withdrawalaccount }}</div>
        <div class="accountInfo">{{ $t('with').Fiatcontractaccount }}</div>
      </div>
      <div class="right">
        <!-- 取款金额 -->
        <div class="tit">{{ $t('with').Withdrawalamount }} </div>
        <div class="numInfo">
          <div class="inputInfo">
            <van-field v-model="currencyAmount" type="number" @input="onInput" :placeholder="$t('recharge').amountMsg">
              <template #right-icon>
                <span style="color: var(--ntext_color)">{{ Currency }}</span>
              </template>
            </van-field>
            <svg-icon class-name="exc" icon-class="exchanges" />
            <van-field v-model="amount" type="number" @input="onInput_USD" :placeholder="$t('recharge').amountMsg">
              <template #right-icon>
                <span style="color: var(--ntext_color)">USD</span>
              </template>
            </van-field>
          </div>
          <div class="selNum">
            <div class="item" v-for="(item, index) in numArr" :key="`num${index}`" @click="onSelectNum(item, index)"
              :class="selNumIndex == index ? 'active' : ''">{{ item }}</div>
          </div>
        </div>
        <!-- 您需取款 -->
        <div class="lables">{{ $t('with').Youneedwithdrawmoney }} <span>{{ amount }} USD</span></div>
        <!-- 您将获得 -->
        <div class="lables">{{ $t('with').Youwillget }} <span>{{ currencyAmount }} {{ Currency }}</span></div>
        <!-- 按钮 -->
        <van-button block :loading="btnloading" @click="handleSub">{{ $t('with').Withdrawimmediately }} </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PopoverSelect,
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      addressList: [],
      rate: 1,
      RateList: [],
      numArr: [200, 500, 1000, 2000, 10000],
      Currency: 'USD',
      Symbol: '$',
      amount: '',
      currencyAmount: '',
      selNumIndex: 0,
      AssetBalance: 0,
      userInfo: {},
      limitAmount: 0,
    }
  },
  async mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    window.scrollTo(0, 0);
    this.getMemberInfo()
    this.getAssetBalance()
    this.getRateList()
    this.getConfig()
    this.currencyAmount = this.numArr[0]
  },
  methods: {
    // 平台配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.limitAmount = res.systemSetting.legalLimitWith
    },
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    // 获取资产余额
    async getAssetBalance() {
      const res = await userApi.getAssetBalance({ assetType: '2', currency: 'USD' })
      this.AssetBalance = res.assetWallet.amount
    },
    // 获取货币汇率
    async getRateList() {
      const res = await systemApi.getRateList()
      this.RateList = res.rate
    },
    //系统钱包地址
    async GetSystemWalletAddress() {
      const res = await systemApi.GetSystemWalletAddress()
      this.addressList = res
      this.onChangeAll()
    },
    // 选择币种
    async onSelect(action) {
      this.Currency = action.text
      this.Symbol = action.symbol
      this.rate = action.val
      if (this.currencyAmount)
        this.onInput()
    },
    //选择数量
    onSelectNum(val, index) {
      this.currencyAmount = val
      this.selNumIndex = index
    },
    //金额输入
    onInput() {
      this.amount = (this.currencyAmount / this.rate).toFixed(6).replace(/\.?0+$/, '')
    },
    onInput_USD() {
      this.currencyAmount = (this.amount * this.rate).toFixed(6).replace(/\.?0+$/, '')
    },
    // 提交
    async handleSub() {
      // 最小提现金额
      if (this.amount < this.limitAmount) {
        this.$toast(this.$t('with').mixAmount + this.limitAmount + ' USD')
        return false
      }
      // 可用余额不足
      if (this.amount > this.AssetBalance) {
        this.$toast(this.$t('with').Insufficientavailablebalance)
        return false
      }
      const form = {
        amount: this.amount,
        currency: this.Currency,
        rate: this.rate,
        currencyAmount: this.currencyAmount,
      }
      this.btnloading = true
      var res = await userApi.withdrawal(form)
      this.btnloading = false
      this.$toast({ message: this.$t('with').subMsg })
      //跳转客服
      let greeting = {
        UserID: this.userInfo.memberId,
        UserName: this.userInfo.memberName,
        OrderID: res.data,
        Amount: this.amount + 'USD',
        Currency: this.Currency,
        CurrencyAmount: this.currencyAmount + this.Currency
      }
      const encoded = encodeURIComponent(JSON.stringify(greeting));
      const metadata = JSON.stringify({ name: this.userInfo.memberId, email: this.userInfo.memberName });
      location.href = ("chatlink.html?greeting=" + encoded + "&metadata=" + + metadata)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      margin-right: 50px;
    }

    .right {
      width: 50%;
    }

    .toptit {
      margin-top: 30px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .toplable {
      margin-top: 10px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
        color: var(--text_color);
        font-weight: bold;
      }
    }

    .tit {
      margin-top: 30px;
      font-size: 14px;
      color: var(--text_color);
    }

    .ric {
      transform: rotate(90deg);
    }

    .selInfo {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;

      &:hover {
        border: 1px solid var(--text_color);
      }

      .left {
        display: flex;
        align-items: center;

        .symbolInfo {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: var(--text_color);
          color: var(--background_color);
          font-size: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .name {
          margin-left: 10px;

          .t1 {
            font-size: 16px;
            font-weight: bold;
            color: var(--text_color);
          }

          .t2 {
            margin-top: 10px;
            font-size: 13px;
            color: var(--ntext_color);
          }
        }

      }
    }

    .addressInfo {
      margin-bottom: 20px;

      .qrcode {
        margin: 20px auto;
        width: 150px;
        height: 150px;
        border: 1px solid var(--info_color);
        border-radius: 10px;
        padding: 10px;

        img {
          width: 130px;
          height: 130px;
        }
      }

      .address {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;

        span {
          width: 88%;
          margin-right: 20px;
          overflow-wrap: break-word;
          font-size: 15px;
          font-weight: bold;
          color: var(--text_color);
        }

        .svgs {
          width: 15px;
          height: 15px;
          color: var(--text_color);
        }
      }
    }

    .accountInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .numInfo {
      margin: 10px 0 50px 0;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 10px;

      .inputInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .exc {
          color: var(--text_color);
          width: 27px;
          height: 27px;
        }
      }

      .selNum {
        margin-top: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .item {
          width: 30%;
          text-align: center;
          padding: 10px 0;
          font-size: 13px;
          color: var(--text_color);
          background: var(--info_color);
          margin: 5px;
          border-radius: 10px;
        }

        .active {
          border: 1px solid #FF9B37;
        }
      }
    }

    .lables {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }

    }

    .van-button {
      margin: 20px 0;
      background: var(--text_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: var(--background_color);
    }

    .van-button:hover {
      opacity: 0.8;
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border-bottom: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>
